import React, { useState, useEffect } from 'react';
import './Loader.css';

function Loader() {
  // Skip loader for widget embed pages (rendered inside iframes)
  const isEmbed = window.location.pathname.startsWith('/widgets/');
  const [isVisible, setIsVisible] = useState(!isEmbed);
  const [logoError, setLogoError] = useState(false);

  useEffect(() => {
    if (isEmbed) {
      document.body.classList.add('loaded');
      return;
    }
    console.log('Loader mounted');

    // Hide loader after 1 second
    const timer = setTimeout(() => {
      console.log('Hiding loader');
      setIsVisible(false);
      // Add 'loaded' class to body after fade out
      setTimeout(() => {
        document.body.classList.add('loaded');
        console.log('Added loaded class to body');
      }, 500);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="loader">
      {!logoError ? (
        <img
          src="/assets_new/img/HL logo_white.svg"
          alt="TraderMap"
          title="TraderMap"
          className="loader-logo"
          onError={(e) => {
            console.error('Failed to load logo:', e.target.src);
            setLogoError(true);
          }}
          onLoad={() => {
            console.log('Logo loaded successfully from:', '/assets_new/img/HL logo_white.svg');
          }}
        />
      ) : (
        <div className="loader-text">
          <h1 style={{ color: '#fff', fontSize: '32px', fontWeight: 'bold' }}>TraderMap</h1>
          <p style={{ color: '#999', fontSize: '14px' }}>Loading...</p>
        </div>
      )}
    </div>
  );
}

export default Loader;
